module.exports = __webpack_public_path__ + "static/media/4-sttpenyehattra.a70f284a.png";